//NPM Packages
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Col, Row, Button } from 'reactstrap';

//Helper files
import './Common.css';

const DynamicModal = ({ isShowing, hide, scope, component }) =>
  isShowing
    ? ReactDOM.createPortal(
        <Fragment>
          <Row
            className="dynamic-modal-wrapper"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
            style={{ height: '50%' }}
          >
            <Col className="dynamic-modal">
              {/* <Row className="dynamic-modal-header" >
                    <Button color="danger" type="button" className="dynamic-modal-close-button" data-dismiss="modal" aria-label="Close" onClick={hide}>
                        <span aria-hidden="true">&times;</span>
                    </Button>
                </Row> */}
              {component}
            </Col>
          </Row>
        </Fragment>,
        document.body
      )
    : null;

export default DynamicModal;
